<div class="bloco-card-small" (click)="irParaRelatorios()">
  <div class="title-with-icon">
    <mat-icon>assessment</mat-icon>
    <h3 class="bloco-title">Relatórios Avançados</h3>
  </div>
  <p class="bloco-desc">
    Acompanhe todos os indicadores das obras do seu time!
  </p>
  <button class="btn-explorar" type="button" (click)="irParaRelatorios(); $event.stopPropagation()">
    Explorar 
  </button>
</div>